var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_1092_13898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 15.6282V17.7357C14.0004 17.9314 13.9602 18.1251 13.8817 18.3043C13.8031 18.4836 13.6879 18.6445 13.5435 18.7768C13.399 18.909 13.2285 19.0097 13.0428 19.0724C12.8571 19.1351 12.6603 19.1584 12.465 19.1408C10.299 18.9059 8.2183 18.1672 6.39023 16.984C4.68945 15.9054 3.24748 14.4663 2.16674 12.7689C0.977102 10.9362 0.236769 8.84954 0.00571348 6.67805C-0.011877 6.48378 0.0112568 6.28798 0.0736417 6.10312C0.136027 5.91826 0.236296 5.7484 0.368066 5.60433C0.499835 5.46027 0.660218 5.34516 0.839003 5.26635C1.01779 5.18753 1.21106 5.14674 1.40651 5.14655H3.51826C3.85987 5.1432 4.19105 5.26393 4.45007 5.48624C4.70909 5.70856 4.87828 6.01729 4.92609 6.35489C5.01522 7.02936 5.18052 7.6916 5.41883 8.32897C5.51354 8.58042 5.53403 8.8537 5.47789 9.11642C5.42175 9.37914 5.29132 9.62029 5.10207 9.8113L4.20809 10.7035C5.21016 12.4623 6.6693 13.9185 8.43159 14.9186L9.32556 14.0264C9.51695 13.8375 9.75858 13.7074 10.0218 13.6513C10.2851 13.5953 10.5589 13.6158 10.8108 13.7103C11.4495 13.9481 12.113 14.1131 12.7888 14.2021C13.1308 14.2502 13.4431 14.4221 13.6663 14.685C13.8895 14.948 14.0081 15.2836 13.9996 15.6282Z",
    fill: "#25245E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10C17.3137 10 20 7.76142 20 5C20 2.23858 17.3137 0 14 0C10.6863 0 8 2.23858 8 5C8 6.13675 8.45522 7.1849 9.22203 8.02476L8.95743 10.803L11.166 9.40819C12.01 9.7858 12.975 10 14 10Z",
    fill: "#25245E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3L16 3",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6L16 6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1092_13898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.0e882fcbc90b05fea57ce2df8b29107a.svg";
export { ForwardRef as ReactComponent };